import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import {
  POSTAL_CODE_REGEX_BY_COUNTRY,
  NO_URLS_REGEX,
} from 'constants/patterns';

const AddressFields = (props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const { address, namePrefix = '' } = props;

  return (
    <>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          name={`${namePrefix}address_line_1`}
          control={control}
          defaultValue={address.address_line_1}
          maxlength={40}
          rules={{
            pattern: NO_URLS_REGEX,
            required: true,
            maxLength: 40,
          }}
          label={t('checkout.label.addressLine1')}
        />
      </Grid>
      <Grid item xs={12} md={12}>
        <ControlledInputText
          name={`${namePrefix}address_line_2`}
          control={control}
          defaultValue={address.address_line_2}
          maxlength={40}
          rules={{
            maxLength: 40,
            pattern: NO_URLS_REGEX,
          }}
          label={t('checkout.label.addressLine2')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}locality`}
          control={control}
          defaultValue={address.sublocality_1 || address.locality}
          rules={{ required: true }}
          label={t('checkout.label.city')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}administrative_district_level_1`}
          control={control}
          defaultValue={address.administrative_district_level_1}
          rules={{ required: true, maxLength: 40 }}
          label={t('checkout.label.state')}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          name={`${namePrefix}postal_code`}
          control={control}
          defaultValue={address.postal_code}
          rules={{
            required: true,
            pattern: {
              value: POSTAL_CODE_REGEX_BY_COUNTRY.GB,
              message: t('error.validation.invalidPostalCode'),
            },
          }}
          label={t('checkout.label.postalCode')}
        />
      </Grid>
    </>
  );
};

export default AddressFields;
